import React from 'react';
import PropTypes from 'prop-types';

const TextWithBold = ({ text }) => {
  let updatedTxt = text;

  if (text) {
    const txtObj = text.split('*');
    updatedTxt = txtObj.map((item, index) => {
      if (item.indexOf('[') > -1) {
        const updatedItem = item.replace('[', '').replace(']', '');
        return (<React.Fragment key={`text-fragment-${index}`}><b>{updatedItem}</b></React.Fragment>);
      }

      return (<React.Fragment key={`text-fragment-${index}`}>{item}</React.Fragment>);
    });
  }

  return updatedTxt;
};

TextWithBold.propTypes = {
  text: PropTypes.string,
};

export default TextWithBold;
